<template>
  <div>
    <div class="page_win renzhengWin" v-if="showtype == 1">
      <div class="topContent">
        <div class="topContent_l" @click="cancelReconiseInfo">
          <span>暂不认证</span>
        </div>
        <div class="topContent_m">
          <span>实名认证</span>
        </div>
        <div class="closeBtn" @click="cancelReconiseInfo">
          <span>关闭</span>
        </div>
      </div>
      <div class="bottomContent">
        <form autocomplete="off">
          <div class="view_group">
            <div class="view_group_l">
              <input
                class="renzhengName"
                type="text"
                name="cardName"
                v-model="cardName"
                placeholder="请输入真实姓名"
              />
            </div>
            <div class="view_group_r" @click="cardName = ''">
              <img :src="close_icon2" alt="" />
            </div>
          </div>

          <div class="view_group">
            <div class="view_group_l">
              <input
                class="renzhengCard"
                type="text"
                name="cardNub"
                v-model="cardNub"
                placeholder="请填写有效身份证信息"
              />
            </div>
            <div class="view_group_r" @click="cardNub = ''">
              <img :src="close_icon2" alt="" />
            </div>
          </div>
        </form>
      </div>
      <div class="bot_btn" @click="toRenzheng">{{ fcmBtnTips }}</div>
      <div class="tip">
        <span><img :src="tip_icon" alt="" />

        {{showInfo.fcmPageTips}}

        <!-- {{ befoStr}} -->

        </span>
      </div>
      <div class="tip">

        <a id="fcmPageRemarkA"> </a>
      </div>
    </div>
    <div class="page_win renzhengWin" v-else-if="showtype == 2">
      <div class="topContent">
        <div class="topContent_m">
          <span>{{showInfo.kfPageTitle}}</span>
        </div>
        <div class="closeBtn" @click="close(1)">
          <img :src="closeImg" />
        </div>
      </div>
      <div class="headContent">
        <div class="headIcon" v-show="showInfo.wxgzhPic">
          <img class="headIcon_img" :src="showInfo.kfPagePic" alt="">
        </div>
        <div class="service_li">
           <div v-html="showInfo.kfPageDescribe"></div>
        </div>
      </div>
      <div class="bot_btn" @click="close">{{showInfo.kfPageButton}}</div>
      <!-- <div class="bot_btn" @click="close">{{ fcmBtnTips }}</div> -->
    </div>
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common.js";
import Clipboard from "clipboard";
export default {
  name: "reconiseInfo",
  inject: ["reload"], //注入App里的reload方法

  data() {
    return {
      showInfo:{},


      fcmBtnTips: "保存",

      adid: "",
      userInfo: "",
      cardName: "",
      cardNub: "",
      returnRightImg: require("../../assets/img/view10/back.png"),
      closeImg: require("../../assets/img/view10/close.png"), // 关闭
      tip_icon: require("../../assets/img/view10/tip.png"), // 关闭
      close_icon2: require("../../assets/img/view10/close2.png"), // 关闭
      okIcon:require("../../assets/img/view10/ok_icon.png"),
      headIcon:require("../../assets/img/view10/headIcon.png"),
      showtype: 1,
    };
  },
  created() {},
  mounted() {
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");

    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};

    this.getShowInfo();
    this.showtype = this.$store.state.winType.reconiseInfoType
    if (this.userInfo.fcm == "1") {
      // this.$store.dispatch("IsReconiseInfoFun", false);
    }
  },
  methods: {
    getShowInfo() {

      this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");

      let _this = this;
        let data = {
        adid: this.adid,
      };
      this.$http.post(fun.apiUrl + "api/common/sdk/init", data).then(
        function (res) {
          _this.showInfo = res.data.data
          _this.fcmBtnTips = res.data.data.fcmBtnTips
          if (this.showtype == 2) return false
          let a = document.getElementById('fcmPageRemarkA')
          a.innerHTML = res.data.data.fcmPageRemark.replace("；","<br/>");;
        },
        function (res) {}
      );
    },
    back(){
      this.showtype = 1;
    },
    close(index) {
      if (index == 1) {
        this.$store.dispatch("IsReconiseInfoFun", false);
      } else if (index == 2) {
        localStorage.removeItem("userInfo");
        this.reload();
      } else {
        if (this.showInfo.kfPageLink) {
          window.location.href = this.showInfo.kfPageLink;
        }
        this.$store.dispatch("IsReconiseInfoFun", false);
      }
    },
    cancelReconiseInfo(){
      console.log(this.userInfo,this.userInfo.loginFcm)
      if(this.userInfo.loginFcm != 1 && this.userInfo.loginFcm != 2){
        this.$store.dispatch("IsReconiseInfoFun", false);//非强制的情况下关闭实名认证窗口
      }else{
        this.$store.dispatch("IsReconiseInfoFun", false);
        this.$store.dispatch("IsReconiseInfoTipFun", true);
      }
    },
    toRenzheng() {
      if (!this.cardName) {
        this.$toast.text("请填写真实姓名");
        return false;
      }
      if (!this.cardNub) {
        this.$toast.text("请填写身份证号码");
        return false;
      }
      let data = {
        adid: this.adid,
        uid: this.userInfo.uid,
        idcard: this.cardNub,
        truename: this.cardName,
      };
      let _this = this;
      this.$http.post(fun.apiUrl + "api/member/setFcm", data).then(
        function (res) {
          if (res.body.code === 200) {
            this.getShowInfo();
            localStorage.removeItem("userLoginMsg");
            if (
              res.body.data != null &&
              res.body.data != "" &&
              res.body.data != undefined
            ) {
              if (this.userInfo.loginFcm == 1) {
                if (res.body.data < 18) {
                  this.$toast.text("未成年人玩家不可登录游戏");
                  setTimeout(function () {
                    localStorage.removeItem("userInfo");
                    _this.reload();
                  }, 1000);
                  return;
                }
              }
            }

            this.userInfo.age = res.body.data;
            this.userInfo.fcm = 1;
            this.fcmBtnTips = '确定';
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
            if (this.showInfo.kfPageShow==1) {
              this.showtype = 2;
            }
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {
          this.toast.text(res.body.msg);
        }
      );
    },
    //复制公众
    copy() {
      let _this = this;
      let btn = this.$refs.btn;
      var clipboard = new Clipboard(btn);
      clipboard.on("success", function(e) {
        _this.$toast.text("已复制");
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
::-webkit-input-placeholder {
  color: #bcbcbc;
}
::-moz-placeholder {
  color: #bcbcbc;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #bcbcbc;
} /* ie */
input:-moz-placeholder {
  color: #bcbcbc;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
    color: #838383
}
.topContent_l,
.topContent_m,
.closeBtn {
  @include flex_box(row, center, center);
}
.topContent_l,
.closeBtn {
  position: absolute;
  top: 0;
  height: 0.68rem;
}
.topContent_l {
  left: 0;
  justify-content: flex-start;
  img {
    width: 0.24rem;
    height: auto;
  }
}
.closeBtn {
  right: 0;
  justify-content: flex-end;
  img {
    width: 0.3rem;
  }
}
.closeBtn2{
  width: auto !important;
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #12CDB0;
    line-height: 0.68rem;
  }
}
.bottomContent {
  // padding: 0 0.24rem;
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
  padding: 0 0.22rem;
  border-radius: 0.1rem;
  margin-top: 0.34rem;
  height: 0.82rem;
  @include flex_box(row, space-between, center);
  border: 1px solid #12CDB0;
}
.view_group_l {
  flex: 1;
  @include flex_box(row, none, center);
  input {
    flex: 1;
    max-width: 4.3rem !important;
    background-color: transparent;
  }
  img {
    margin-right: 0.24rem;
  }
  .phone_icon {
    width: 0.32rem;
    height: 0.42rem;
  }
  .pwd_icon {
    width: 0.36rem;
    height: 0.38rem;
  }
}
.view_group_r {
  @include flex_box(row, center, center);
  img {
    width: 0.28rem;
    height: 0.28rem;
  }
}
.tip {
  @include flex_box(row, space-between, flex-start);
  margin-top: 0.1rem;
  font-size: 12px;
  color: #FA1659;
  img {
    width: 0.24rem;
    height: auto;
    margin-right: 0.1rem;
    vertical-align: top;
  }
  a{
    color: #254AEA;
    line-height: .3rem
  }
  span{
    line-height: .3rem
  }
}
.headContent{
  @include flex_box(row, space-between, center);
  padding-top: .1rem ;
}
.headIcon{
  @include flex_box(row, center, center);
  position: relative;
  width: 2.2rem;
  margin: .06rem 0;
}
.service_li{
  flex: 1;
  margin-left: .1rem;
  @include flex_box(column, center, none);

}
.headIcon_img{
  width:2.2rem;
  height: auto;
}
.okIcon{
  position: absolute;
  right: -.12rem;
  bottom: 0;
  @include flex_box(row, center, center);
  img{
    width: .78rem;
    height: auto;
  }
}
.headContent_tip{
  font-size: 12px;
  color: #919194;
  line-height: 0.36rem;
  text-align: center;
}
.copy_tip{
  font-size: 12px;
  color: #12CDB0;
  line-height: 0.36rem;
}
</style>



// WEBPACK FOOTER //
// src/views/view10/reconiseInfo.vue